import { Box, Button, OutlinedInput, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';
import { useConfig } from '../../hooks/useConfig';
import { passwordLoginEnabled } from './passwordLoginEnabled';

function Login(): JSX.Element {
  const { login, loginFailed, ssoLogin } = useAuth();
  const { apiHost } = useConfig();

  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const location = useLocation() as any;
  const from = location.state?.from?.pathname || '/admin/contracts';

  const showPasswordLogin = passwordLoginEnabled({
    envFlag: import.meta.env.VITE_ENABLE_PASSWORD_LOGIN,
    isDev: import.meta.env.DEV,
  });

  const loginWithSSO = () => {
    ssoLogin(apiHost);
  };

  const submitLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    login(username, password, from, apiHost);
  };

  return (
    // centered MUI box
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <Stack direction="column" alignItems="center">
        <Typography variant="h4">Welcome to the OneDSP</Typography>
        <br />
        {/* left justify */}
        <Box sx={{ marginLeft: '50px', width: '100%', textAlign: 'left' }}>
          <Typography variant="h5">Please sign in to continue:</Typography>
        </Box>
        <Box sx={{ width: '100%' }} p={3}>
          <Stack spacing={2} direction="column">
            <Button variant="contained" color="primary" onClick={loginWithSSO}>
              Login with SSO
            </Button>
          </Stack>
        </Box>
        {showPasswordLogin && (
          <Box component="form" sx={{ width: '100%' }} p={3} onSubmit={(e) => submitLogin(e)}>
            <Stack spacing={2} direction="column">
              <Typography variant="body2">
                Local development only — sign in against the database instead of SSO.
              </Typography>
              <OutlinedInput
                sx={{ width: '100%' }}
                type="text"
                value={username}
                name="user[email]"
                id="user_email"
                autoComplete="off"
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Hi, my username is"
              />
              <OutlinedInput
                sx={{ width: '100%' }}
                type="password"
                name="user[password]"
                id="user_password"
                autoComplete="off"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="And my password is"
              />
              {/* AuthContextType declares loginFailed as boolean, but the provider
                  assigns the server's error string to it, which is what renders here. */}
              {loginFailed && (
                <Typography variant="body1" sx={{ color: 'red' }}>
                  {loginFailed}
                </Typography>
              )}
              <Button variant="contained" color="primary" type="submit">
                Log me in
              </Button>
            </Stack>
          </Box>
        )}
        <Box sx={{ marginLeft: '50px', width: '100%', textAlign: 'left' }}>
          <Typography variant="body1">Not registered yet?</Typography>
          <Typography variant="body2">
            Please contact your Thinknear Account Manager for registration details.
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}

export default Login;
